import * as Cookies from 'js-cookie';

const state = {
  user: Cookies.getJSON('user'),
  loggedIn: !!Cookies.getJSON('user.loggedIn'),
  auth_error: null,
  email_reset_error: null,
  reg_error: null,
  reset_error: null,
};

const mutations = {
  email: (state) => {
    state.email_reset_error = null;
  },
  emailResetSuccess: (state) => {
    state.email_reset_error = null;
  },
  emailResetFailed: (state, payload) => {
    const err = payload.error.response.data.errors;
    state.email_reset_error = Object.values(err)[0][0];
  },
  login: (state) => {
    state.auth_error = null;
  },
  loginSuccess: (state, payload) => {
    const userObject = Object.assign({}, payload.user, {
      token: payload.access_token,
    });
    state.auth_error = null;
    state.user = userObject;
    state.loggedIn = true;
  },
  loginFailed: (state, payload) => {
    state.auth_error = payload.error;
  },
  logout: (state) => {
    state.auth_error = null;
  },
  logoutSuccess: (state, payload) => {
    state.loggedIn = false;
    state.user = payload;
  },
  logoutFailed: (state, payload) => {
    const err = payload.error.response.data.errors;
    state.auth_error = Object.values(err)[0][0];
  },
  register: (state) => {
    state.reg_error = null;
  },
  registrationSuccess: (state) => {
    state.reg_error = null;
  },
  registrationFailed: (state, payload) => {
    const err = payload.error.response.data.errors;
    state.reg_error = Object.values(err)[0][0];
  },
  reset: (state) => {
    state.reset_error = null;
  },
  resetSuccess: (state) => {
    state.reset_error = null;
  },
  resetFailed: (state, payload) => {
    const err = payload.error.response.data.errors;
    state.reset_error = Object.values(err)[0][0];
  },
};

const actions = {
  email: ({ commit }) => commit('email'),
  login: ({ commit }) => commit('login'),
  logout: ({ commit }) => commit('logout'),
  register: ({ commit }) => commit('register'),
  reset: ({ commit }) => commit('reset'),
};

const getters = {
  user: (state) => state.user,
  loggedIn: (state) => state.loggedIn,
  authError: (state) => state.auth_error,
  emailResetError: (state) => state.email_reset_error,
  regError: (state) => state.reg_error,
  resetError: (state) => state.reset_error,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
